// General Animations
import * as clearSequence from './animation/atoms/clearSequence';
import * as fade from './animation/atoms/fade';
import * as position from './animation/atoms/position';
import * as rotate from './animation/atoms/rotate';
import * as scale from './animation/atoms/scale';
import * as sequence from './animation/atoms/sequence';
import * as timelineAnimation from './animation/atoms/timelineAnimation';

// In Animations
import * as arcIn from './animation/in/defaults/arcIn';
import * as bounceIn from './animation/in/defaults/bounceIn';
import * as dropIn from './animation/in/defaults/dropIn';
import * as expandIn from './animation/in/defaults/expandIn';
import * as fadeIn from './animation/in/defaults/fadeIn';
import * as flipIn from './animation/in/defaults/flipIn';
import * as floatIn from './animation/in/defaults/floatIn';
import * as flyIn from './animation/in/defaults/flyIn';
import * as foldIn from './animation/in/defaults/foldIn';
import * as glideIn from './animation/in/defaults/glideIn';
import * as reveal from './animation/in/defaults/reveal';
import * as slideIn from './animation/in/defaults/slideIn';
import * as spinIn from './animation/in/defaults/spinIn';
import * as turnIn from './animation/in/defaults/turnIn';

// Out Animations
import * as arcOut from './animation/out/arcOut';
import * as bounceOut from './animation/out/bounceOut';
import * as collapseOut from './animation/out/collapseOut';
import * as conceal from './animation/out/conceal';
import * as fadeOut from './animation/out/fadeOut';
import * as flipOut from './animation/out/flipOut';
import * as floatOut from './animation/out/floatOut';
import * as flyOut from './animation/out/flyOut';
import * as foldOut from './animation/out/foldOut';
import * as glideOut from './animation/out/glideOut';
import * as popOut from './animation/out/popOut';
import * as slideOut from './animation/out/slideOut';
import * as spinOut from './animation/out/spinOut';
import * as turnOut from './animation/out/turnOut';

// Mode Transition Animations
import * as ModesMotionNoDimensions from './animation/modes/ModesMotionNoDimensions';
import * as ModesMotionNoScale from './animation/modes/ModesMotionNoScale';
import * as ModesMotionScale from './animation/modes/ModesMotionScale';

// Background Smooth Scroll Effects Base
import * as baseBgClipPath from './animation/backgroundSmoothScrollEffects/base/baseBgClipPath';
import * as baseBgFade from './animation/backgroundSmoothScrollEffects/base/baseBgFade';
import * as baseBgParallaxY from './animation/backgroundSmoothScrollEffects/base/baseBgParallaxY';
import * as baseBgPositionX from './animation/backgroundSmoothScrollEffects/base/baseBgPositionX';
import * as baseBgPositionY from './animation/backgroundSmoothScrollEffects/base/baseBgPositionY';
import * as baseBgRotate from './animation/backgroundSmoothScrollEffects/base/baseBgRotate';
import * as baseBgScale from './animation/backgroundSmoothScrollEffects/base/baseBgScale';
import * as baseBgSkew from './animation/backgroundSmoothScrollEffects/base/baseBgSkew';
import * as baseBgZoom from './animation/backgroundSmoothScrollEffects/base/baseBgZoom';

// background Smooth Scroll Effects
// Stub
import * as backgroundParallaxZoom from './animation/backgroundScrollEffects/backgroundParallaxZoom';

// Classic
import * as bgFadeIn from './animation/backgroundSmoothScrollEffects/bgFadeIn';
import * as bgParallax from './animation/backgroundSmoothScrollEffects/bgParallax';
import * as bgReveal from './animation/backgroundSmoothScrollEffects/bgReveal';

// New
import * as bgCloseUp from './animation/backgroundSmoothScrollEffects/bgCloseUp';
import * as bgExpand from './animation/backgroundSmoothScrollEffects/bgExpand';
import * as bgFadeBack from './animation/backgroundSmoothScrollEffects/bgFadeBack';
import * as bgFadeOut from './animation/backgroundSmoothScrollEffects/bgFadeOut';
import * as bgFake3D from './animation/backgroundSmoothScrollEffects/bgFake3D';
import * as bgPanLeft from './animation/backgroundSmoothScrollEffects/bgPanLeft';
import * as bgPanRight from './animation/backgroundSmoothScrollEffects/bgPanRight';
import * as bgPullBack from './animation/backgroundSmoothScrollEffects/bgPullBack';
import * as bgRotate from './animation/backgroundSmoothScrollEffects/bgRotate';
import * as bgShrink from './animation/backgroundSmoothScrollEffects/bgShrink';
import * as bgSkew from './animation/backgroundSmoothScrollEffects/bgSkew';
import * as bgUnwind from './animation/backgroundSmoothScrollEffects/bgUnwind';
import * as bgZoomIn from './animation/backgroundSmoothScrollEffects/bgZoomIn';
import * as bgZoomOut from './animation/backgroundSmoothScrollEffects/bgZoomOut';
import * as imageParallax from './animation/backgroundSmoothScrollEffects/imageParallax';
import * as imageReveal from './animation/backgroundSmoothScrollEffects/imageReveal';

// Background Scroll Effects
import * as backgroundBlurIn from './animation/backgroundScrollEffects/backgroundBlurIn';
import * as backgroundFadeIn from './animation/backgroundScrollEffects/backgroundFadeIn';
import * as backgroundParallax from './animation/backgroundScrollEffects/backgroundParallax';
import * as backgroundReveal from './animation/backgroundScrollEffects/backgroundReveal';
import * as backgroundZoom from './animation/backgroundScrollEffects/backgroundZoom';
import * as siteBackgroundParallax from './animation/backgroundScrollEffects/siteBackgroundParallax';

// Component specific animations
import * as HeaderFadeOut from './animation/componentAnimations/HeaderFadeOut';
import * as HeaderFadeOutCustom from './animation/componentAnimations/HeaderFadeOutCustom';
import * as headerHideToTop from './animation/componentAnimations/headerHideToTop';
import * as HeaderMoveCustom from './animation/componentAnimations/HeaderMoveCustom';

export {
  fade,
  position,
  scale,
  rotate,
  sequence,
  clearSequence,
  timelineAnimation,
  arcIn,
  dropIn,
  expandIn,
  fadeIn,
  flipIn,
  floatIn,
  flyIn,
  foldIn,
  reveal,
  slideIn,
  spinIn,
  turnIn,
  bounceIn,
  glideIn,
  arcOut,
  popOut,
  collapseOut,
  fadeOut,
  flipOut,
  floatOut,
  flyOut,
  foldOut,
  conceal,
  slideOut,
  spinOut,
  turnOut,
  bounceOut,
  glideOut,
  ModesMotionNoScale,
  ModesMotionNoDimensions,
  ModesMotionScale,
  baseBgFade,
  baseBgPositionX,
  baseBgPositionY,
  baseBgParallaxY,
  baseBgRotate,
  baseBgScale,
  baseBgSkew,
  baseBgZoom,
  baseBgClipPath,
  backgroundParallaxZoom,
  bgParallax,
  bgReveal,
  bgFadeIn,
  bgZoomIn,
  bgZoomOut,
  bgCloseUp,
  bgPullBack,
  bgFadeOut,
  bgPanLeft,
  bgPanRight,
  bgRotate,
  bgUnwind,
  bgFake3D,
  bgSkew,
  bgFadeBack,
  bgShrink,
  bgExpand,
  imageParallax,
  imageReveal,
  siteBackgroundParallax,
  backgroundReveal,
  backgroundParallax,
  backgroundZoom,
  backgroundFadeIn,
  backgroundBlurIn,
  headerHideToTop,
  HeaderMoveCustom,
  HeaderFadeOut,
  HeaderFadeOutCustom,
};
